<!-- eslint-disable no-tabs -->
<template>
	<section class="trabajos">
		<div class="trabajos__container">
			<h1 class="title">Trabajos</h1>
			<div class="trabajos__content">
				<div class="trabajos__content__expanded" v-if="selectedWork">
					<transition name="fade" mode="out-in">
						<div>
							<hooper :key="windowWidth" :items-to-show="1" :wheel-control="false" :mouse-drag="false"
								:touch-drag="false">
								<slide v-for="(image, i) in selectedWork.images" :key="`image-${i}}`" :index="i">
									<img :src="image.mobile" class="trabajos__content__expanded--image" v-if="!isDesktop" />
									<img :src="image.desktop" class="trabajos__content__expanded--image" v-if="isDesktop" />
								</slide>
								<slide v-if="selectedWork.videos && validateVideoVersion(video)" v-for="(video, i) in selectedWork.videos" :key="`image-${i}}`">
									<div class="vPlayer">
										<div class="content">
											<iframe :src="`https://player.vimeo.com/video/${vimeoId(
												video.video.uri
											)}?loop=1`" webkitallowfullscreen mozallowfullscreen allowfullscreen width="100%" height="100%"></iframe>
										</div>
									</div>
								</slide>
								<hooper-navigation slot="hooper-addons"></hooper-navigation>
							</hooper>
							<button class="close" @click="changeWork(null)">
								<img src="/img/png/reduce.png" />
							</button>
						</div>
					</transition>
				</div>

				<div class="grid-wrapper" :class="{ 'hidden': selectedWork }">
					<trabajos-carousel-mobile :grilla1="grilla1" :grilla2="grilla2" @select="changeWork">
					</trabajos-carousel-mobile>
					<trabajos-carousel-desktop ref="grilla" :grilla1="grilla1" :grilla2="grilla2" @select="changeWork">
					</trabajos-carousel-desktop>
				</div>
				<!--  -->
			</div>
		</div>
	</section>
</template>

<script>
import 'hooper/dist/hooper.css'
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper'
import TrabajosCarouselDesktop from '@/components/restyling/trabajos/TrabajosCarouselDesktop'
import TrabajosCarouselMobile from '@/components/restyling/trabajos/TrabajosCarouselMobile'

export default {
  components: {
    TrabajosCarouselDesktop,
    TrabajosCarouselMobile,
    Hooper,
    Slide,
    HooperNavigation
  },
  data () {
    return {
      selectedWork: null,
      windowWidth: 0,
      isDesktop: window.innerWidth >= 1280
    }
  },
  methods: {
    onSwiper (swiper) {
      console.log('swiper: ', swiper)
    },
    async changeWork (item) {
      if (item) { // ? este if es para evitar error de "property of undefined"
        if (item.images.length >= 1 || item.idFolder) {
          this.selectedWork = item

          if (item.idFolder) {
            await this.$store.dispatch('getVideosByFolder', {
              idFolder: item.idFolder,
              slug: item.slug
            })
          }
        }
      } else {
        this.selectedWork = null
      }
    },
    vimeoId (val) {
      let id = val.split('/')
      return id[2]
    },
    updateDesktopStatus () {
      this.isDesktop = window.innerWidth >= 768 // Update the status based on window width
    },
    validateVideoVersion (video) {
      if (window.innerWidth >= 768) {
        return video.video.width >= video.video.height
      } else {
        return video.video.width < video.video.height
      }
    }
  },
  computed: {
    trabajos () {
      return this.$store.state.trabajos
    },
    grilla1 () {
      const trabajosTotal = this.trabajos.length
      const trabajosPerGrid = Math.ceil(trabajosTotal / 2)
      const grilla = this.trabajos.slice(0, trabajosPerGrid)

      return grilla
    },
    grilla2 () {
      const trabajosTotal = this.trabajos.length
      const trabajosPerGrid = Math.ceil(trabajosTotal / 2)
      const grilla = this.trabajos.slice(
        trabajosPerGrid,
        Math.ceil(trabajosTotal)
      )

      return grilla
    }
  },
  mounted () {
    this.$nextTick(() => {
      addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })

    this.$store.dispatch('getReelFolders')

    window.addEventListener('resize', this.updateDesktopStatus)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateDesktopStatus)
  }
}
</script>
